import React, { FC, useState } from 'react';
import { FaBars } from 'react-icons/fa';
import { TiArrowBack } from 'react-icons/ti';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { Button } from 'devextreme-react/button';

import { useSelector } from 'bus';

import { Tooltip } from 'devextreme-react';

import { changeCollapsed } from '../../../bus/config/actions';
import './header.sass';
import LogOutModal from './modal-log-out';

const Header: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { drawerCollapsed } = useSelector((store) => store.config);

  const [visible, setVisible] = useState(false);
  const [visibleDrawer, setVisibleDrawer] = useState(false);

  const backButtonHandler = () => {
    history.goBack();
  };

  const toggleDefault = () => setVisible(!visible);
  const toggleDefaultDrawer = () => setVisibleDrawer(!visibleDrawer);

  const drawerButtonHandler = () => {
    localStorage.setItem('drawerStatus', `${!drawerCollapsed}`);
    dispatch(changeCollapsed(!drawerCollapsed));
  };

  const isDev = process.env.NODE_ENV === 'development';

  return (
    <div
      className="header-panel"
      style={{
        background: isDev ? '#ffac71' : '#fff',
      }}
    >
      <div className="header-panel__left">
        <Tooltip target="#back" position="bottom" visible={visible}>
          <div>Назад</div>
        </Tooltip>
        <Tooltip target="#drawer" position="bottom" visible={visibleDrawer}>
          <div>Свернуть/развернуть меню</div>
        </Tooltip>
        <span id="back" onMouseEnter={toggleDefault} onMouseLeave={toggleDefault}>
          <Button width={30} type="normal" onClick={backButtonHandler} stylingMode="text">
            <TiArrowBack size={20} />
          </Button>
        </span>

        <span id="drawer" onMouseEnter={toggleDefaultDrawer} onMouseLeave={toggleDefaultDrawer} className="ml-1">
          <Button width={30} type="normal" onClick={drawerButtonHandler} stylingMode="text">
            <FaBars style={{ marginTop: 3 }} />
          </Button>
        </span>
        {isDev && <span className="ml-2">DEV MODE</span>}
      </div>
      <div className="header-panel__right">
        <LogOutModal />
      </div>
    </div>
  );
};

export default Header;
